<template>
  <div v-touch:swipe="handleSwipe" class="Slider pt-8 lg:pt-10 w-full">
    <div class="pb-5.5 lg:pb-7.5">
      <div :class="wrapperClass">
        <div v-if="data.length > 1" :class="prevButtonClass" class="h-full">
          <div class="h-full flex items-center">
            <transition name="fade">
              <button
                v-if="showPrevArrow"
                class="w-full h-20 pointer-events-auto focus:outline-none"
                @click="handlePrevItem"
              >
                <span class="grid grid-cols-2 w-full">
                  <span class="col-start-2 col-span-1 h-full">
                    <svg class="w-auto h-5 fill-current" viewBox="0 0 15 30">
                      <path
                        d="M14.1421 0.857865L0 15L14.1421 29.1421V0.857865Z"
                      />
                    </svg>
                  </span>
                </span>
              </button>
            </transition>
          </div>
        </div>
        <div :class="wrapperInnerClass">
          <div class="relative z-10">
            <div class="relative">
              <template v-for="(item, index) in data">
                <transition :name="`Slider-image-${direction}`">
                  <div
                    v-show="index === activeIndex"
                    :key="index"
                    class="relative z-10"
                  >
                    <img
                      v-if="item.image"
                      class="w-full pointer-events-none"
                      :src="item.image[0].url"
                      :alt="item.image[0].title"
                    />
                    <div v-else class="relative">
                      <VideoComponent
                        :video-class="videoClass"
                        :poster="item.posterImage[0].url"
                        :url="item.videoUrl"
                        can-control-audio
                      />
                    </div>
                  </div>
                </transition>
              </template>
            </div>
          </div>
        </div>
        <div v-if="data.length > 1" :class="nextButtonClass" class="h-full">
          <div class="h-full flex items-center">
            <transition name="fade">
              <button
                v-if="showNextArrow"
                class="w-full h-20 pointer-events-auto focus:outline-none"
                @click="handleNextItem"
              >
                <span class="grid grid-cols-2 w-full">
                  <span class="col-start-1 col-span-1 h-full ml-auto">
                    <svg class="w-auto h-5 fill-current" viewBox="0 0 15 30">
                      <path
                        d="M0.857865 29.1421L15 15L0.857865 0.857865V29.1421Z"
                      />
                    </svg>
                  </span>
                </span>
              </button>
            </transition>
          </div>
        </div>
      </div>
      <div :class="wrapperClass">
        <div :class="wrapperInnerClass">
          <div class="relative">
            <template v-for="(item, index) in data">
              <transition name="Slider-text">
                <div v-if="index === activeIndex" :key="index">
                  <div
                    v-if="item.primaryText || item.secondaryText"
                    class="uppercase lg:flex pt-2.5"
                  >
                    <h3
                      v-if="item.primaryText"
                      class="lg:w-1/2"
                      v-html="nl2br(item.primaryText)"
                    />
                    <h3
                      v-if="item.secondaryText"
                      class="lg:w-1/2 lg:text-right"
                      v-html="nl2br(item.secondaryText)"
                    />
                  </div>
                </div>
              </transition>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div :class="wrapperClass">
      <div :class="wrapperInnerClass">
        <div
          v-if="data.length > 1"
          :class="bulletsInside ? 'absolute inset-x-0 z-10 bottom-0 pb-5' : ''"
        >
          <SliderBullets
            :items="data.length"
            :active-index="activeIndex"
            :bullet-class="bulletClass"
            :bullet-active-class="bulletActiveClass"
            @click="handleBulletClick"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SliderBullets from "./SliderBullets.vue";
import SliderMixin from "./SliderMixin.vue";
import VideoComponent from "../components/VideoComponent.vue";

export default {
  name: "SliderBase",
  components: {
    SliderBullets,
    VideoComponent,
  },
  mixins: [SliderMixin],
  props: {
    canControlAudio: {
      type: Boolean,
    },
  },
  data() {
    return {
      isMuted: true,
    };
  },
  methods: {
    toggleAudio() {
      this.isMuted = !this.isMuted;
    },
  },
};
</script>

<style scoped src="./Slider.css"></style>
